// Фильтр

import {h} from 'preact';
import SmartSticky from '~/app/elements/SmartSticky';
import {
	addScreenModeListener,
	removeScreenModeListener,
	ScreenMode,
} from '~/app/utils/Screen';
import FilterForm from './FilterForm';
import {SubscribedComponent} from './Store/index';
import State from './Store/State';

/**
 * Component Properties
 */
interface FilterProps
{
	[key: string]: void;
}

/**
 * Component State
 */
interface FilterState
{
	[key: string]: void;
}

/**
 * Фильтр
 */
class Filter extends SubscribedComponent<State, FilterProps, FilterState>
{
	/**
	 * Автоматически закрепляемый объект.
	 */
	private sticky: SmartSticky | undefined;
	/**
	 * Элемент, который нужно автоматически закреплять.
	 */
	private filterContainer: HTMLElement;
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		this.sticky = new SmartSticky(
			this.filterContainer,
			{
				createPlaceholder: false,
			},
		);
		
		addScreenModeListener( this.onScreenModeChange );
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		removeScreenModeListener( this.onScreenModeChange );
		
		if ( !this.sticky )
		{
			return;
		}
		
		this.sticky.destroy();
		this.sticky = undefined;
	}
	
	/**
	 * Render component
	 */
	public render(): JSX.Element
	{
		return (
			<div class="filter"
				ref={this.refFilterContainer}
			>
				<h1>Выбрать квартиру</h1>
				<FilterForm />
			</div>
		);
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(): void
	{
		if ( this.sticky )
		{
			this.sticky.update();
		}
	}
	
	/**
	 * При изменении режима экрана.
	 */
	private onScreenModeChange = ( mode: ScreenMode ): void =>
	{
		if ( !this.sticky )
		{
			return;
		}
		
		if ( mode < ScreenMode.NOTEBOOK )
		{
			this.sticky.disable();
		}
		else
		{
			this.sticky.enable();
		}
	}
	
	/**
	 * Сохраняет ссылку на кормевой элемент.
	 */
	private refFilterContainer = ( element: HTMLElement ): void =>
	{
		this.filterContainer = element;
	}
}

/**
 * Module.
 */
export {
	Filter as default,
	FilterProps,
	FilterState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/Filter.tsx